import React, {Component} from 'react';
import Product from './Product';

class ProductDetail extends Component {
  constructor() {
    super();
    this.state = {
      product: [],
      loadedProducts: false,
    };
  }

  componentWillMount() {
    if (
      this.props.collections.length &&
      this.props.body_style === 'shopify_product'
    ) {
      //Requires only one product in collection
      this.grabCollectionProducts(this.props.collections[0].id);
    } else {
      const handle = this.props.match.params.handle;
      this.props.client.product.fetchByHandle(handle).then(product => {
        this.setState({
          product: [product],
          loadedProducts: true,
        });
      });
    }
  }

  grabCollectionProducts = (id) => {
    this.props.client.collection.fetchWithProducts(id).then(res => {
      this.setState({
        product: res.products,
        loadedProducts: true,
      });
    });
  }

  render() {
    let product = this.state.product.map(product => {
      return (
        <Product
          addVariantToCart={this.props.addVariantToCart}
          checkout={this.props.checkout}
          client={this.props.client}
          key={product.id.toString()}
          product={product}
          more={true}
          style={this.props.style}
        />
      );
    });

    return <div>{product}</div>;
  }
}

export default ProductDetail;



// WEBPACK FOOTER //
// ./src/components/ProductDetail.js